import { axiosPlatform } from "./axios-helper";
import { getSessionId } from "./session";
import { UserRole } from "../_statics/UserStatics";

const SESSION_KEY = "metaLoginTrackedSession";

let trackedSessionInMemory = null;
const inFlightSessions = new Set();

const isTrackableUser = (user) =>
    !!user?.selectedOrganization && user?.userRole !== UserRole.SUPER_USER && user?.userRole !== UserRole.TECHNICAL_USER;

const isTracked = (sessionId) => {
    if (trackedSessionInMemory === sessionId) {
        return true;
    }
    try {
        return sessionStorage.getItem(SESSION_KEY) === sessionId;
    } catch (e) {
        return false;
    }
};

const markTracked = (sessionId) => {
    trackedSessionInMemory = sessionId;
    try {
        sessionStorage.setItem(SESSION_KEY, sessionId);
    } catch (e) {
        return;
    }
};

export const pageUrlWithoutParams = () => window.location.origin + window.location.pathname;

const cookieValue = (name) => document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]+)"))?.[1] || undefined;

export const withMetaBrowserData = (requestBody) => ({
    ...requestBody,
    fbp: cookieValue("_fbp"),
    fbc: cookieValue("_fbc"),
    eventSourceUrl: pageUrlWithoutParams(),
});

export const trackExistingCustomerLogin = (user) => {
    const sessionId = getSessionId();
    if (!isTrackableUser(user) || !sessionId || inFlightSessions.has(sessionId) || isTracked(sessionId)) {
        return;
    }
    inFlightSessions.add(sessionId);
    axiosPlatform()
        .post("/meta/login-event", withMetaBrowserData({}))
        .then(() => markTracked(sessionId))
        .catch(() => {})
        .finally(() => {
            inFlightSessions.delete(sessionId);
        });
};
